var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"custom-btn",class:{ 'custom-btn--transparent': _vm.transparent, 'custom-btn--initial-width': _vm.initial },style:({ width: _vm.width }),attrs:{"color":"transparent","disabled":_vm.disabled,"depressed":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }